import { render, staticRenderFns } from "./AdminTeacherListIndex.vue?vue&type=template&id=1c7d087c"
import script from "./AdminTeacherListIndex.vue?vue&type=script&lang=js"
export * from "./AdminTeacherListIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports